import PropTypes from 'prop-types';
import styled from 'styled-components';
import _noop from 'lodash/noop';

import { media } from '@mlb/react-patterns/style/helpers/media.ts';

import Btn from '../../containers/FilterButton';
import { FILTER_BREAKPOINT } from '../../utils/constants';

const FilterButton = styled(Btn).attrs(props => ({
    size: 'md',
    onClick: props.onClick,
}))`
    display: block;

    ${media[`lgmin`]`
        display: none;
    `}

`;

FilterButton.propTypes = {
    onClick: PropTypes.func,
};

FilterButton.defaultProps = {
    onClick: _noop,
};

export default FilterButton;
